export default __webpack_public_path__ + "static/media/girl.8398b69b.svg";